import { render, staticRenderFns } from "./pdf-reader.vue?vue&type=template&id=b4f829cc&scoped=true"
import script from "./pdf-reader.vue?vue&type=script&lang=js"
export * from "./pdf-reader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f829cc",
  null
  
)

export default component.exports